// Guest cart persisted in localStorage. NO PII — only product/variant refs, price snapshot & qty.
const KEY = "hallogbs_shop_cart";

export function readCart() {
  try {
    const raw = localStorage.getItem(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

function writeCart(items) {
  localStorage.setItem(KEY, JSON.stringify(items));
  window.dispatchEvent(new Event("shop-cart-changed"));
  return items;
}

export function cartCount() {
  return readCart().reduce((n, it) => n + (it.qty || 0), 0);
}

export function cartSubtotal() {
  return readCart().reduce((s, it) => s + (it.price || 0) * (it.qty || 0), 0);
}

export function addToCart(line) {
  // line: {product_id, variant_id, name, variant_label, price, img_id, stock}
  const items = readCart();
  const idx = items.findIndex((i) => i.product_id === line.product_id && i.variant_id === line.variant_id);
  const max = Number.isFinite(line.stock) ? line.stock : Infinity;
  if (idx >= 0) {
    items[idx].qty = Math.min(max, (items[idx].qty || 0) + (line.qty || 1));
    items[idx].price = line.price;
    items[idx].name = line.name;
    items[idx].variant_label = line.variant_label;
    items[idx].img_id = line.img_id;
    items[idx].stock = line.stock;
  } else {
    items.push({ ...line, qty: Math.min(max, line.qty || 1) });
  }
  return writeCart(items);
}

export function setQty(product_id, variant_id, qty) {
  const items = readCart();
  const idx = items.findIndex((i) => i.product_id === product_id && i.variant_id === variant_id);
  if (idx < 0) return items;
  const max = Number.isFinite(items[idx].stock) ? items[idx].stock : Infinity;
  const q = Math.max(0, Math.min(max, qty));
  if (q === 0) items.splice(idx, 1);
  else items[idx].qty = q;
  return writeCart(items);
}

export function removeFromCart(product_id, variant_id) {
  return writeCart(readCart().filter((i) => !(i.product_id === product_id && i.variant_id === variant_id)));
}

export function clearCart() {
  return writeCart([]);
}
